<template>
    <van-dialog
            v-model:show="data.show"
            :title="pops.title"
            :close-on-click-overlay="pops.isOverlay"
            :show-confirm-button="false"
            :show-cancel-button="false">
        <slot/>
        <slot name="btn">
            <div class="padding-15 btn-group" v-if="pops.isConfirm || pops.isCancel">
                <div class="confirm margin-bottom-10 btn" @click="onConfirm" v-if="pops.isConfirm">
                    {{pops.confirmText}}
                </div>
                <div class="cancel margin-bottom-10 btn" @click="onCancel" v-if="pops.isCancel">
                    {{pops.cancelText}}
                </div>
            </div>
        </slot>
    </van-dialog>
</template>

<script lang="ts">
  import {defineComponent, reactive, onBeforeMount, getCurrentInstance, watch} from 'vue';
  import { Toast } from 'vant';

  export default defineComponent({
    props: {
      show: Boolean,
      title: String,
      width: String,
      message: String,
      confirmText:String,
      cancelText:String,
      isConfirm:Boolean,
      isCancel:Boolean,
      isOverlay:Boolean
    },
    setup(props) {
      const data = reactive({
        show:false
      });

      const pops = reactive({
        ...props
      });

      const { ctx }: any = getCurrentInstance();

      const close = () => {
        data.show = false;
      };

      const open = () => {
        data.show = true;
      };

      const onConfirm = () => {
        ctx.$emit("confirm");
        close();
      };

      const onCancel = () => {
        ctx.$emit("cancel");
        close();
      };

      onBeforeMount(() => {

      });
      return {
        close,
        open,
        data,
        pops,
        onConfirm,
        onCancel
      };
    }
  });
</script>

<style lang="scss" scoped>
    @import "../assets/scss/common.scss";

    .van-dialog {
        border-radius: 20px;
        font-size: 28px;
        width: 600px;
    }

    .van-dialog__header {
        font-size: 30px;
    }

    .btn-group {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .confirm {
        background: $primary-color;
    }

    .cancel{
        background: $err-color;
    }

    .btn{
        width: 70%;
        line-height: 67px;
        border-radius: 10px;
        color: #ffffff;
        font-size: 30px;
        text-align: center;
        margin-bottom: 10px;
    }

</style>

